import { startOfDay } from 'date-fns/esm';
import { Project, UserSettings } from 'timeghost-api';
import { isAdmin, isProjectManager } from './permission';
import userProjectFind from './userProjectFind';

// Helper Function for Comego
export function lockComeoPast(currentUser: UserSettings, selectedUserId: string) {
  const blockComego = currentUser.workspace.settings.blockComego;
  const mode: string = blockComego?.pastMode;
  if (!mode || mode === 'none') return null;
  const isAdmin = !!currentUser.workspace.users.find((x) => x.admin && x.id === currentUser.id);

  if (isAdmin) return null;
  if (currentUser.id != selectedUserId) return null;

  if (mode === 'none') {
    return null;
  } else if (mode == 'date') {
    return new Date(blockComego.pastDate);
  } else {
    const period = blockComego.period;
    const range: string = blockComego.range;
    let allowedDate = startOfDay(new Date());
    if (range === 'day') {
      allowedDate.setDate(allowedDate.getDate() - period);
    } else if (range === 'week') {
      allowedDate.setDate(allowedDate.getDate() - period * 7);
    } else if (range === 'month') {
      allowedDate.setMonth(allowedDate.getMonth() - period);
    }
    return allowedDate;
  }
}
export function isLockedComegoTimesDate(currentUser: UserSettings, date: Date) {
  const blockComego = currentUser.workspace.settings.blockComego;
  const mode: string = blockComego?.pastMode;
  if (!mode || mode === 'none') return null;
  const userIsAdmin = isAdmin(currentUser);
  let allowedDate;
  if (userIsAdmin) return false;
  if (mode === 'none') {
    return false;
  } else if (mode == 'date') {
    allowedDate = new Date(blockComego.pastDate);
  } else {
    const period = blockComego.period;
    const range: string = blockComego.range;
    allowedDate = startOfDay(new Date());
    if (range === 'day') {
      allowedDate.setDate(allowedDate.getDate() - period);
    } else if (range === 'week') {
      allowedDate.setDate(allowedDate.getDate() - period * 7);
    } else if (range === 'month') {
      allowedDate.setMonth(allowedDate.getMonth() - period);
    }
  }
  return date < allowedDate;
}

// Helper Functions for Times
export function lockTimesPast(currentUser: UserSettings, project: any) {
  const blockTimes = currentUser.workspace.settings.blockTimes;
  if (!blockTimes) return null;
  const mode: string = blockTimes.pastMode;
  const isAdmin = !!currentUser.workspace.users.find((x) => x.admin && x.id === currentUser.id);
  const isManager = userProjectFind(currentUser, project, { projectManager: true, workspaceAdmin: true });
  //const isManager = false;

  if (isAdmin) return null;
  if (isManager) return null;

  if (mode === 'none') {
    return null;
  } else if (mode == 'date') {
    return new Date(blockTimes.pastDate);
  } else {
    const period = blockTimes.period;
    const range: string = blockTimes.range;
    let allowedDate = startOfDay(new Date());

    switch (range) {
      case 'day':
        allowedDate.setDate(allowedDate.getDate() - period);
      case 'week':
        allowedDate.setDate(allowedDate.getDate() - period * 7);
      case 'month':
        allowedDate.setMonth(allowedDate.getMonth() - period);
    }
    return allowedDate;
  }
}

export function isLockedProjectTimesDate(currentUser: UserSettings, project: Project | null | undefined, date: Date) {
  const blockTimes = currentUser.workspace.settings.blockTimes;
  if (!blockTimes) return false;
  const mode: string = blockTimes.pastMode;
  if (!mode) return false;
  const isAdmin = !!currentUser.workspace.users.find((x) => x.admin && x.id === currentUser.id);
  const isManager = project && isProjectManager(currentUser.id, currentUser.workspace, project);
  //const isManager = false;
  let allowedDate = startOfDay(new Date());
  if (isAdmin) return false;
  if (isManager) return false;

  if (!mode || mode === 'none') {
    return false;
  } else if (mode == 'date') {
    allowedDate = new Date(blockTimes.pastDate);
  } else {
    const period = blockTimes.period;
    const range: string = blockTimes.range;
    switch (range) {
      case 'day':
        allowedDate.setDate(allowedDate.getDate() - period);
      case 'week':
        allowedDate.setDate(allowedDate.getDate() - period * 7);
      case 'month':
        allowedDate.setMonth(allowedDate.getMonth() - period);
    }
  }
  return date < allowedDate;
}
